import { Observable } from 'rxjs';

// Value stored in a files control: one entry per uploaded document. `id` is present once the
// document is persisted server-side (company documents, PO detail); absent for a file that only
// exists in file-manager so far.
export interface UploadedFileValue {
  id?: number;
  key: string;
  name: string;
  uploadedAt: string;
}

export interface FilesCardLabels {
  dropzone: string;
  browse: string;
  uploading: string;
  preview: string;
  remove: string;
  download: string;
}

export interface FilesCardMessages {
  invalidFormat: string;
  sizeExceeded: string;
  maxFilesExceeded: string;
  uploadFailed: string;
  uploadComplete: string;
  removed: string;
  removeFailed: string;
}

export const FILES_CARD_ERROR_TYPE = {
  INVALID_FORMAT: 'invalid_format',
  SIZE_EXCEEDED: 'size_exceeded',
  MAX_FILES_EXCEEDED: 'max_files_exceeded',
  UPLOAD_FAILED: 'upload_failed',
} as const;

export type FilesCardErrorType = typeof FILES_CARD_ERROR_TYPE[keyof typeof FILES_CARD_ERROR_TYPE];

export interface FilesCardError {
  type: FilesCardErrorType;
  files: string[];
}

// Persistence hooks. No hook = local-only: append/splice the form control (PO flow — the
// documents travel inline in POST/PUT when the form is saved). A hook = the consumer owns
// persistence (company flow — immediate POST/DELETE against /companies/:id/documents).
export type PersistAddedFn = (
  added: UploadedFileValue[],
  current: UploadedFileValue[],
) => Observable<UploadedFileValue[]>;

export type PersistRemovedFn = (
  file: UploadedFileValue,
  current: UploadedFileValue[],
) => Observable<UploadedFileValue[]>;
